import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogDataEnum } from '../../../enums/dialog.enum';

@Component({
  imports: [MatDialogModule],
  selector: 'bodyanalytics-booking-reschedule-dialog',
  templateUrl: './booking-reschedule-dialog.component.html',
  styleUrls: ['./booking-reschedule-dialog.component.scss'],
})
export class BookingRescheduleDialogComponent {
  protected dialogEnum = DialogDataEnum;
}
